import Toolbar from "@imminently/decisively-ui/Toolbar";
import { EditorToolbarButton, MarkToolbarButton, useToolbarHistoryState } from "@/common/editor/plugins/toolbar";

import Icon from "@imminently/decisively-ui/Icon";
import { FloatingVerticalDivider, LinkToolbarButton } from "@udecode/plate";
import { MARK_BOLD, MARK_ITALIC, MARK_STRIKETHROUGH, MARK_UNDERLINE } from "@udecode/plate";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

export const HistoryToolbar = ({ editorId }: { editorId?: string } = {}) => {
  const { canUndo, canRedo } = useToolbarHistoryState(editorId);

  return (
    <>
      <EditorToolbarButton
        id={editorId}
        key="undo"
        icon={<Icon name="undo" />}
        tooltip="Undo"
        hotkeys={["mod", "z"]}
        onClick={(e) => e.undo()}
        disable={!canUndo}
      />
      <EditorToolbarButton
        id={editorId}
        key="redo"
        icon={<Icon name="redo" />}
        tooltip="Redo"
        hotkeys={["mod", "shift", "z"]}
        onClick={(e) => e.redo()}
        disable={!canRedo}
      />
    </>
  );
};

const FontToolbar = () => {
  const { t } = useTranslation();
  return (
    <>
      <MarkToolbarButton
        icon={<Icon name="bold" />}
        type={MARK_BOLD}
        tooltip={t("documents.bold_tooltip")}
        hotkeys={["mod", "b"]}
      />
      <MarkToolbarButton
        icon={<Icon name="italic" />}
        type={MARK_ITALIC}
        tooltip={t("documents.italic_tooltip")}
        hotkeys={["mod", "i"]}
      />
      <MarkToolbarButton
        icon={<Icon name="underline" />}
        type={MARK_UNDERLINE}
        tooltip={t("documents.underline_tooltip")}
        hotkeys={["mod", "u"]}
      />
      <MarkToolbarButton
        icon={<Icon name="strikethrough" />}
        type={MARK_STRIKETHROUGH}
        tooltip={t("documents.strikethrough_tooltip")}
        hotkeys={["mod", "shift", "x"]}
      />
    </>
  );
};

export const RichTextToollbar = ({ children }: PropsWithChildren) => {
  return (
    <>
      <Toolbar.Group>
        <FontToolbar />
      </Toolbar.Group>
      <FloatingVerticalDivider />
      <Toolbar.Group>
        <LinkToolbarButton icon={<Icon name="public-link" />} />
      </Toolbar.Group>
      {children}
    </>
  );
};
